import { FieldConfig } from '../../common/field-types';

import { renderRateScheduleField } from '../_shared';
import {
  APV_REGIME_OPTIONS,
  GENDER_OPTIONS,
  PRIME_PERIODICITY_OPTIONS,
  RATE_MODE_OPTIONS,
  SAVINGS_OPTION_OPTIONS,
  isFixedRate,
  isIdealPensionMode,
  isSavingsCapacityMode,
  isSteppedRate,
} from '../apv-select/schema';
import { APVHorizonteFormValues, COMPENSATION_PLAN_OPTIONS } from './schema';

const CLIENTE = 'Datos del cliente';
const POLIZA = 'Detalle de la póliza';
const CAPITALES = 'Capitales';
const MODO = 'Modo y campos específicos';
const APORTES = 'Aportes y primas';

export const APV_HORIZONTE_FIELDS: readonly FieldConfig<APVHorizonteFormValues>[] = [
  {
    key: 'date_of_birth', label: 'Fecha de nacimiento', kind: 'date', section: CLIENTE,
  },
  {
    key: 'gender', label: 'Género', kind: 'select', options: GENDER_OPTIONS, section: CLIENTE,
  },
  {
    key: 'net_salary', label: 'Salario neto', kind: 'number', hint: 'UF', section: POLIZA,
  },
  {
    key: 'afp_balance', label: 'Saldo AFP', kind: 'number', hint: 'UF', section: POLIZA,
  },
  {
    key: 'expected_retirement', label: 'Edad de jubilación esperada', kind: 'number', hint: 'Años', section: POLIZA,
  },
  {
    key: 'apv_regime', label: 'Régimen APV', kind: 'select', options: APV_REGIME_OPTIONS, section: POLIZA,
  },
  {
    key: 'compensation_plan', label: 'Plan de compensación', kind: 'select', options: COMPENSATION_PLAN_OPTIONS, section: POLIZA,
  },
  {
    key: 'payment_periodicity', label: 'Periodicidad prima', kind: 'select', options: PRIME_PERIODICITY_OPTIONS, section: POLIZA,
  },
  {
    key: 'death_insured_capital', label: 'Capital muerte', kind: 'number', hint: 'UF', colClassName: 'col-md-6', section: CAPITALES,
  },
  {
    key: 'accidental_death_insured_capital', label: 'Capital muerte accidental', kind: 'number', hint: 'UF', colClassName: 'col-md-6', section: CAPITALES,
  },
  {
    key: 'itp_insured_capital', label: 'Capital ITP', kind: 'number', hint: 'UF (= capital muerte o 0)', colClassName: 'col-md-6', section: CAPITALES,
  },
  {
    key: 'rate_mode', label: 'Modo de tasa', kind: 'select', options: RATE_MODE_OPTIONS, section: MODO,
  },
  {
    key: 'projection_rate', label: 'Tasa de proyección', kind: 'number', hint: 'Anual, ej. 0.03', step: 0.01, visibleWhen: isFixedRate, section: MODO,
  },
  {
    key: 'projection_rate_schedule',
    label: 'Tramos de tasa',
    kind: 'custom',
    hint: 'Cada tramo aplica hasta el mes "Hasta" inclusive. El último puede dejarse "para siempre".',
    visibleWhen: isSteppedRate,
    render: renderRateScheduleField,
    section: MODO,
  },
  {
    key: 'savings_option', label: 'Modo de ahorro', kind: 'select', options: SAVINGS_OPTION_OPTIONS, section: MODO,
  },
  {
    key: 'ideal_pension', label: 'Pensión ideal', kind: 'number', hint: 'UF (solo si modo = Pensión ideal)', visibleWhen: isIdealPensionMode, section: MODO,
  },
  {
    key: 'agreed_premium', label: 'Prima convenida', kind: 'number', hint: 'Min 2.2 mensual', visibleWhen: isSavingsCapacityMode, section: APORTES,
  },
  {
    key: 'apv_transfer_amount', label: 'Traspaso APV', kind: 'number', hint: 'UF', section: APORTES,
  },
  {
    key: 'initial_contribution', label: 'Aporte inicial', kind: 'number', hint: 'UF (aterriza en el inicio de la póliza)', section: APORTES,
  },
  {
    key: 'initial_agreed_deposit', label: 'Depósito convenido inicial', kind: 'number', hint: 'UF', colClassName: 'col-md-6', section: APORTES,
  },
  {
    key: 'annual_agreed_deposits', label: 'Depósitos convenidos anuales', kind: 'number', hint: 'UF', colClassName: 'col-md-6', section: APORTES,
  },
  {
    key: 'direct_contribution_amount', label: 'Aporte único', kind: 'number', hint: 'UF (adicional al aporte inicial; único, con mes propio)', colClassName: 'col-md-6', section: APORTES,
  },
  {
    key: 'direct_contribution_month', label: 'Mes del aporte único', kind: 'number', hint: '1 = inicio. Base 1. Se ignora si el aporte es 0.', colClassName: 'col-md-6', section: APORTES,
  },
  {
    key: 'annual_direct_contribution', label: 'Aporte anual', kind: 'number', hint: 'UF', section: APORTES,
  },
];
